/* eslint-disable */
import React, { useEffect, useState } from "react";
import Statistics from "..";
import {
  getPropertiesStats,
  getStatisticsSuccess,
  getActiveUsers,
} from "../../../actions";
import "./styles.scss";
import { connect } from "react-redux";
import Popup from "reactjs-popup";
import PeriodSelector from "../../PeriodSelector";
import infoIcon from "../../../assets/icons/info-gray-new.svg";
import { history } from "../../../config/stores";

const rentTypesShortcuts = [
  {
    key: "landlordOnlyProperties",        // Match your API response
    label: "RENTED OUT PROPERTIES",
  },
  {
    key: "tenantOnlyProperties",          // Match your API response
    label: "RENTED PROPERTIES", 
  },
  {
    key: "tenantAndLandlordProperties",   // Match your API response
    label: "OWNED TOGETHER WITH TENANTS",
  },
];

const Properties = ({ getPropertiesStats, properties, sessions }) => {
  const [selected, setSelected] = useState("country");
  const [selPeriod, setSelPeriod] = useState({
    startDate: null,
    endDate: null,
  });
  const [hasUserChangedPeriod, setHasUserChangedPeriod] = useState(false);
  const [selectedPeriodLabel, setSelectedPeriodLabel] = useState("All time");
  const [selectedPeriodType, setSelectedPeriodType] = useState("all");

  useEffect(() => {
    getStatisticsSuccess({ type: "properties", loading: true });
    getPropertiesStats({
      startDate: "",
      endDate: ""
    });
  }, []);

  useEffect(() => {
    // Only trigger API call when user has actually changed the period
    if (hasUserChangedPeriod) {
      const apiPayload = {
        startDate: selPeriod.startDate || "",
        endDate: selPeriod.endDate || "",
      };
      
      getPropertiesStats(apiPayload);
    }
  }, [selPeriod, hasUserChangedPeriod]);

  const handlePeriodApply = (periodData) => {
    setSelPeriod({
      startDate: periodData.startDate,
      endDate: periodData.endDate,
    });
    setSelectedPeriodLabel(periodData.label);
    setSelectedPeriodType(periodData.type);
    setHasUserChangedPeriod(true);
  };

  const handlePropertiesListClick = () => {
    // Navigate to the properties list page with period parameters
    const queryParams = new URLSearchParams();
    
    if (selPeriod.startDate) {
      queryParams.set('startDate', selPeriod.startDate);
    }
    if (selPeriod.endDate) {
      queryParams.set('endDate', selPeriod.endDate);
    }
    if (selectedPeriodLabel !== "All time") {
      queryParams.set('periodLabel', selectedPeriodLabel);
    }
    if (selectedPeriodType !== "all") {
      queryParams.set('periodType', selectedPeriodType);
    }
    
    const queryString = queryParams.toString();
    const url = queryString ? `/dashboard/properties/list?${queryString}` : '/dashboard/properties/list';
    
    history.push(url);
  };

  return (
    <div
      className="statistics-sessions-container col"
      style={{ overflow: "auto" }}
    >
      {/* Row 1: PROPERTIES title and period selector */}
      <div className="properties-header">
        <h1 className="properties-title">
          <b>PROPERTIES</b>
        </h1>
        <div className="period-selector">
          <p className="period-label">
            {selectedPeriodLabel}
          </p>
          <Popup
            className="popup-header-options-container"
            trigger={<div className="settings-icon" />}
            position="bottom right"
            closeOnDocumentClick
          >
            {(close) => (
              <PeriodSelector
                selectedPeriod={selectedPeriodType}
                onApply={(periodData) => {
                  handlePeriodApply(periodData);
                  close();
                }}
              />
            )}
          </Popup>
        </div>
      </div>

      {/* Row 2: Blue background with total properties */}
      <div className="total-properties-row">
        <div className="indicator" />
        <div className="total-properties-content">
          <span className="properties-count">{properties?.propertiesCount || 0}</span>
          <span className="properties-text">CREATED IN THE APP</span>
        </div>
        <img 
          src={infoIcon} 
          alt="Info" 
          className="info-icon" 
          onClick={() => handlePropertiesListClick()}
          style={{ cursor: "pointer" }}
        />
      </div>

      <div
        className="statistics-sessions-content"
        style={{ overflow: "unset" }}
      >
        <div className="statistics-sessions-section col"  style={{marginBottom:"20px"}}>
          <h4>LOCATION</h4>
          <div className="selector-container">
            <div
              className={`select ${selected === "country" && "selected"}`}
              onClick={() => setSelected("country")}
            >
              BY COUNTRY
            </div>
            <div
              className={`select ${selected === "city" && "selected"}`}
              onClick={() => setSelected("city")}
            >
              BY CITY
            </div>
          </div>
          {properties.loading ? (
            <Statistics.LoaderInline />
          ) : (
            <>
              {selected === "country" ? (
                <Statistics.Horizontal
                  data={properties?.groupedByCountry?.map((prop) => {
                    return {
                      value: prop.country,
                      label: prop.count,
                      info: true, // Enable info icon
                    };
                  })}
                  handleInfo={({ value, label }) => {
                    // Navigate to properties filtered by country with current period
                    const queryParams = new URLSearchParams();
                    queryParams.set('country', value); // Don't encode here, let URLSearchParams handle it
                    
                    // Add period filters if they exist
                    if (selPeriod.startDate) {
                      queryParams.set('startDate', selPeriod.startDate);
                    }
                    if (selPeriod.endDate) {
                      queryParams.set('endDate', selPeriod.endDate);
                    }
                    if (selectedPeriodLabel !== "All time") {
                      queryParams.set('periodLabel', selectedPeriodLabel);
                    }
                    
                    history.push(`/dashboard/properties/list?${queryParams.toString()}`);
                  }}
                />
              ) : (
                <Statistics.Horizontal
                  data={properties?.groupedByCity?.map((prop) => {
                    return {
                      value: prop.city,
                      label: prop.count,
                      info: true, // Enable info icon
                    };
                  })}
                  handleInfo={({ value, label }) => {
                    // Navigate to properties filtered by city with current period
                    const queryParams = new URLSearchParams();
                    queryParams.set('city', value); // Don't encode here, let URLSearchParams handle it
                    
                    // Add period filters if they exist
                    if (selPeriod.startDate) {
                      queryParams.set('startDate', selPeriod.startDate);
                    }
                    if (selPeriod.endDate) {
                      queryParams.set('endDate', selPeriod.endDate);
                    }
                    if (selectedPeriodLabel !== "All time") {
                      queryParams.set('periodLabel', selectedPeriodLabel);
                    }
                    
                    history.push(`/dashboard/properties/list?${queryParams.toString()}`);
                  }}
                />
              )}
            </>
          )}
        </div>
        <div className="statistics-sessions-section col"  style={{marginBottom:"20px"}}>
          <h4>TYPE</h4>
          {properties.loading ? (
            <Statistics.LoaderInline />
          ) : (
            <Statistics.Horizontal
              data={properties?.groupedByType?.map((prop) => {
                return {
                  value: prop.type,
                  label: prop.count,
                  info: true, // Enable info icon
                };
              })}
              handleInfo={({ value, label }) => {
                // Navigate to properties filtered by type with current period
                const queryParams = new URLSearchParams();
                queryParams.set('propertyType', value);
                
                // Add period filters if they exist
                if (selPeriod.startDate) {
                  queryParams.set('startDate', selPeriod.startDate);
                }
                if (selPeriod.endDate) {
                  queryParams.set('endDate', selPeriod.endDate);
                }
                if (selectedPeriodLabel !== "All time") {
                  queryParams.set('periodLabel', selectedPeriodLabel);
                }
                
                history.push(`/dashboard/properties/list?${queryParams.toString()}`);
              }}
            />
          )}
        </div>
        <div className="statistics-sessions-section col hidden-section" style={{marginBottom:"20px"}}>
          <h4>STATUS</h4>
          
          <div className="statistics-info-box smaller full-width">
            <div style={{ display: "flex", height: "100%" }}>
              <div className="indicator gray" />
              <h4 className="statistics-info-box-text" style={{fontSize:"1.25rem"}}>
                {properties?.ownedProperties?.count} OWNED PROPERTIES
              </h4>
            </div>
          </div>
          
          {rentTypesShortcuts.map((pair, i) => {
            return (
              <div className="statistics-info-box bigger full-width" key={i}>
                <div
                  style={{
                    display: "flex",
                    height: "18%",
                    border: "1px solid #b0d1fa",
                    borderRadius: "6px",
                    padding: "7px",
                  }}
                >
                  <div className="indicator gray" />
                  <h4 className="statistics-info-box-text" style={{fontSize:"1.25rem"}}>
                    {properties?.[pair.key]?.count} {pair.label}
                  </h4>
                </div>
                <div style={{ padding: "10px" }}>
                  <h4 style={{ margin: "0.5rem 0" }}>MONTHLY RENT</h4>
                  {properties.loading ? (
                    <Statistics.LoaderInline />
                  ) : (
                    <Statistics.Horizontal
                      data={properties?.[pair.key]?.groupedByRentRange?.map(
                        (prop) => {
                          return {
                            value: prop.range,
                            label: prop.count,
                          };
                        }
                      )}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sessions: state.dashboard.sessions,
  properties: state.dashboard.properties,
  activeUsers: state.dashboard.activeUsers,
});
const mapDispatchToProps = (dispatch) => ({
  getPropertiesStats: (payload) => dispatch(getPropertiesStats(payload)),
  getActiveUsers: (payload) => dispatch(getActiveUsers(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Properties);
